import React from "react";

function Footer() {
  return <div>
    foot
  </div>;
}

export default Footer;
